const PREFS_URL = process.env.API_URL + '/prescriber/preferences';

const getCatalogAccess = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(PREFS_URL + '/catalog-access')
      .then((response) => resolve(response.body), error => reject(error));
  });
};

const setCatalogAccess = (context, glucovibesCatalogAccess) => {
  return new Promise((resolve, reject) => {
    context.$http.put(PREFS_URL + '/catalog-access', { glucovibesCatalogAccess })
      .then((response) => resolve(response.body), error => reject(error));
  });
};

export default {
  getCatalogAccess,
  setCatalogAccess
};



// WEBPACK FOOTER //
// ./src/brand/health/api/prescriberPreferences/index.js